"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.polling = function (func) {
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  var timeout = arguments.length > 2 ? arguments[2] : undefined;
  var timeoutCallback = arguments.length > 3 ? arguments[3] : undefined;
  var intervalId = setInterval(func, interval);
  if (timeout) setTimeout(function () {
    clearInterval(intervalId);
    if (timeoutCallback) timeoutCallback();
  }, timeout);
  return intervalId;
};

exports.debounce = function (func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var immediate = arguments.length > 2 ? arguments[2] : undefined;
  var timeout;
  return function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = this;

    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

exports.throttle = function (func) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var lastFunc;
  var lastRan;
  return function throttled() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var context = this;

    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
};

var FUNCTION_UTILS = {
  polling: exports.polling,
  debounce: exports.debounce,
  throttle: exports.throttle
};
exports.default = FUNCTION_UTILS;